'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Button, Row } from 'react-bootstrap';
const Moment = require('moment');
const uuid = require('uuid');
import DatePicker from 'react-datepicker';
const get = require('lodash/get');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const StringUtil = require('../../../../app/shared/StringUtil');
const ExportsUtil = require('../../util/ExportsUtil');
const AnalyticsActions = require('../../actions/AnalyticsActions');
const ServerRequest = require('../../actions/request');
const AnalyticsStore = require('../../stores/AnalyticsStore');
import withActivityData from '../DataHOCs/WithActivityData';
import ErrorBox from '../common/ErrorBox';
import SuccessBox from '../common/SuccessBox';
import LoadingSpinner from '../loading/LoadingSpinner';
import LoadingWithCancel from '../loading/LoadingWithCancel';

const propTypes = {
    onClose: PropTypes.func.isRequired,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    activityStoreState: PropTypes.shape({
        activity: PropTypes.shape({
            title: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    show: PropTypes.bool,
};

const defaultProps = {
    show: true,
};

class ActivityCompletionStatsModal extends React.Component {
    constructor(props) {
        super(props);

        this.pollTaskManager = new ServerRequest.PollTaskManager();
        const analyticsStoreState = AnalyticsStore.getState();
        let startDate;
        let endDate;
        let retrievedStartDate = null;
        let retrievedEndDate = null;
        const storeStartDate = get(analyticsStoreState, ['activityCompletionStatsDates', props.activityId, 'startDate']);
        const actCompletionStats = get(analyticsStoreState, ['activityCompletionStats', props.activityId, 'attRecords'], null);
        if (!storeStartDate) {
            startDate = Moment().subtract(1, 'Y').month(0).date(1).toDate();
        }
        else {
            startDate = Moment(storeStartDate).toDate();
            if (!!actCompletionStats) {
                retrievedStartDate = Moment(storeStartDate);
            }
        }

        const storeEndDate = get(analyticsStoreState, ['activityCompletionStatsDates', props.activityId, 'endDate']);
        if (!storeEndDate) {
            endDate = Moment().subtract(1, 'Y').month(11).date(31).toDate();
        }
        else {
            endDate = Moment(storeEndDate).toDate();
            if (!!actCompletionStats) {
                retrievedEndDate = Moment(storeEndDate);
            }
        }

        this.state = {
            getAnalyticsError: null,
            getAnalyticsActionId: null,
            actCompletionStats: actCompletionStats,
            pendingGetAnalytics: analyticsStoreState.activityCompletionStatsPending, // an operation which has been started, may not be for this project
            startDate: startDate, // Date
            endDate: endDate, // Date
            retrievedStartDate: retrievedStartDate, // Moment
            retrievedEndDate: retrievedEndDate, // Moment
        };

        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.onEndDateChange = this.onEndDateChange.bind(this);
        this.onUpdateDateRange = this.onUpdateDateRange.bind(this);
        this.cancelGetAnalytics = this.cancelGetAnalytics.bind(this);
        this.onExport = this.onExport.bind(this);
        this.unsubscribes = [AnalyticsStore.listen(this.onAnalyticsStoreChange.bind(this))];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
        this.pollTaskManager.abandonTasks();
    }

    onAnalyticsStoreChange(newState) {
        let additionalState = {
            pendingGetAnalytics: newState.activityCompletionStatsPending,
        };
        if (newState.action.id === this.state.getAnalyticsActionId) {
            if (!newState.action.error) {
                additionalState = {
                    ...additionalState,
                    getAnalyticsActionId: null,
                    actCompletionStats: newState.activityCompletionStats[this.props.activityId].attRecords,
                    retrievedStartDate: Moment(newState.activityCompletionStatsDates[this.props.activityId].startDate),
                    retrievedEndDate: Moment(newState.activityCompletionStatsDates[this.props.activityId].endDate),
                }
            }
            else {
                additionalState = {
                    ...additionalState,
                    getAnalyticsActionId: null,
                    getAnalyticsError: newState.action.error
                };
            }
        }

        this.setState({ ...additionalState });
    }

    onStartDateChange(date) {
        this.setState({ startDate: date });
    }

    onEndDateChange(date) {
        this.setState({ endDate: date });
    }

    onUpdateDateRange() {
        const analyticsStoreState = AnalyticsStore.getState();
        if (
            !!analyticsStoreState.activityCompletionStats[this.props.activityId]
            && !!analyticsStoreState.activityCompletionStatsDates[this.props.activityId]
            && analyticsStoreState.activityCompletionStatsDates[this.props.activityId].startDate === Moment(this.state.startDate).format('YYYY-MM-DD')
            && analyticsStoreState.activityCompletionStatsDates[this.props.activityId].endDate === Moment(this.state.endDate).format('YYYY-MM-DD')
        ) { // this data is already loaded in the client
            this.setState({
                actCompletionStats: analyticsStoreState.activityCompletionStats[this.props.activityId].attRecords,
                startDate: Moment(analyticsStoreState.activityCompletionStatsDates[this.props.activityId].startDate).toDate(),
                endDate: Moment(analyticsStoreState.activityCompletionStatsDates[this.props.activityId].endDate).toDate(),
                retrievedStartDate: Moment(analyticsStoreState.activityCompletionStatsDates[this.props.activityId].startDate),
                retrievedEndDate: Moment(analyticsStoreState.activityCompletionStatsDates[this.props.activityId].endDate),
            });
        }
        else {
            if (!!this.state.getAnalyticsActionId || !!this.state.pendingGetAnalytics) {
                return; // fetch only one at a time
            }

            const getAnalyticsActionId = uuid.v4();
            if (this.state.getAnalyticsActionId) {
                this.pollTaskManager.cancelAction(this.state.getAnalyticsActionId);
            }

            this.setState({
                    getAnalyticsActionId: getAnalyticsActionId,
                    getAnalyticsError: null,
                    retrievedStartDate: null,
                    retrievedEndDate: null,
                }, () => {
                    AnalyticsActions.getActivityCompletionStats(
                        getAnalyticsActionId,
                        {
                            channelId: this.props.channelId,
                            activityId: this.props.activityId,
                            startDate: Moment(this.state.startDate),
                            endDate: Moment(this.state.endDate)
                        }, this.pollTaskManager
                    );
                });
        }
    }

    cancelGetAnalytics(e) {
        e.stopPropagation(); // prevent whole page refresh
        if (this.state.getAnalyticsActionId) {
            const cancelledActionId = this.state.getAnalyticsActionId;
            this.pollTaskManager.cancelAction(cancelledActionId);
            this.setState({ getAnalyticsActionId: null }, () => {
                AnalyticsActions.cancelActivityCompletionStats(cancelledActionId);
            });
        }
    }

    onExport() {
        if (!this.state.actCompletionStats) return;
        
        const actTitle = get(this.props, ['activityStoreState', 'activity', 'title'], Strings['en'].common.ACTIVITY);
        const tableArr = [];
        const headerRow = [
            Strings['en'].analytics.overview.completion_act_stats_export.CSV_HEAD_STUD_F_NAME,
            Strings['en'].analytics.overview.completion_act_stats_export.CSV_HEAD_STUD_L_NAME,
            Strings['en'].analytics.overview.completion_act_stats_export.CSV_HEAD_STUD_EMAIL,
            Strings['en'].analytics.overview.completion_act_stats_export.CSV_HEAD_TIME_PLAYED,
            Strings['en'].analytics.overview.completion_act_stats_export.CSV_HEAD_SCORE
        ];
        tableArr.push(headerRow);
        this.state.actCompletionStats.forEach((attRecord) => {
            const attRow = [];
            attRow.push(ExportsUtil._escapeCommas(attRecord.first_name));
            attRow.push(ExportsUtil._escapeCommas(attRecord.last_name));
            attRow.push(ExportsUtil._escapeCommas(attRecord.third_party_email));
            attRow.push(ExportsUtil._escapeCommas(StringUtil.getTimeStringForMs(attRecord.time_played)));
            attRow.push(ExportsUtil._escapeCommas(StringUtil.formatOverallScore(attRecord.score)));
            tableArr.push(attRow);
        });

        const csvContent = ExportsUtil._generateCsvText(tableArr);
        const fileName = `${actTitle}_${this.state.retrievedStartDate.format('YYYY-MM-DD')}-${this.state.retrievedEndDate.format('YYYY-MM-DD')}.csv`;
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, fileName);
        }
        else {
            let link = document.createElement("a");
            const csvUrl = URL.createObjectURL(blob);
            link.setAttribute('href', csvUrl);
            link.setAttribute("download", fileName);
            link.innerHTML= 'Download CSV file';
            document.body.appendChild(link); // Required for FF
            link.click();
            document.body.removeChild(link);
        }
    }

    render() {
        return (
            <Modal
                show={this.props.show}
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                size="lg"
                onHide={this.props.onClose}
            >
                <Modal.Header closeButton onHide={this.props.onClose}>
                    <Modal.Title>{Strings['en'].analytics.overview.completion_act_stats_export.HEADING}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ErrorBox error={this.state.getAnalyticsError} />
                    <Form className="margin-bottom-lg">
                        <Row>
                            <div className="col-12 col-sm-6 margin-bottom-lg">
                                <label className="label-form margin-right-sm">
                                    {Strings['en'].common.START_DATE}
                                </label>
                                <DatePicker
                                    className="margin-right-md"
                                    selected={this.state.startDate}
                                    onChange={this.onStartDateChange}
                                    minDate={Moment(Globals.date.SERVICE_DATE_MIN_YYYY_MM_DD).toDate()}
                                    maxDate={this.state.maxDate}
                                />
                            </div>
                            <div className="col-12 col-sm-6 margin-bottom-lg">
                                <label className="label-form margin-right-sm">
                                    {Strings['en'].common.END_DATE}
                                </label>
                                <DatePicker
                                    className="margin-right-md"
                                    selected={this.state.endDate}
                                    onChange={this.onEndDateChange}
                                    minDate={this.state.startDate}
                                    maxDate={new Date()}
                                />
                            </div>
                            <div className="col-12">
                                <Button
                                    disabled={!!this.state.getAnalyticsActionId || !!this.state.pendingGetAnalytics}
                                    onClick={this.onUpdateDateRange}
                                >
                                    {Strings['en'].analytics.overview.export.RETRIEVE_DATA}
                                </Button>
                                {(!!this.state.pendingGetAnalytics) ?
                                        (!!this.state.getAnalyticsActionId) ?
                                        <span className="margin-left-lg">
                                            <LoadingWithCancel className="margin-right-sm" 
                                                loadingText={Strings['en'].analytics.overview.export.DATA_RETRIEVING_SELF} 
                                                onCancel={this.cancelGetAnalytics}/>
                                        </span>
                                        :
                                        <span className="margin-left-lg"><LoadingSpinner className="margin-right-sm" />{Strings['en'].analytics.overview.completion_act_stats_export.DATA_RETRIEVING_OTHER}</span>
                                    :
                                    null
                                }
                            </div>
                        </Row>
                    </Form>
                    {(!!this.state.actCompletionStats && !this.state.getAnalyticsActionId) &&
                        <SuccessBox>
                            {Strings['en'].analytics.overview.export.DATA_RETRIEVED_RANGE} {Moment(this.state.retrievedStartDate).format('YYYY/MM/DD')} - {Moment(this.state.retrievedEndDate).format('YYYY/MM/DD')}
                            {(this.state.actCompletionStats.length > 0) ?
                                <p className="margin-top-sm">{Strings['en'].analytics.overview.export.EXPORT_GUIDANCE}</p>
                                :
                                <p className="margin-top-sm">{Strings['en'].analytics.overview.completion_act_stats_export.EXPORT_GUIDANCE_NO_RES}</p>
                            }
                            <div className="text-align-center margin-top-lg">
                                <Button
                                    disabled={this.state.actCompletionStats.length === 0}
                                    onClick={this.onExport}
                                >
                                    {Strings['en'].common.EXPORT_CSV}
                                </Button>
                            </div>
                        </SuccessBox>
                    }
                </Modal.Body>
            </Modal>
        );
    }
}

ActivityCompletionStatsModal.propTypes = propTypes;
ActivityCompletionStatsModal.defaultProps = defaultProps;

export default withActivityData(ActivityCompletionStatsModal);